import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

export function createStore() {
    return new Vuex.Store({
        state: {
            isWebpSupported: true,
            openedGameWindows: [],
            maintenanceMode: undefined,
            errorMode: undefined,
            translatedCurrentPageRoutes: undefined,
            itemTranslationLanguages: [],
            isDeviceMobile: false,
            deviceOrientation: undefined,
            lobbyBox: undefined,
            lobbyMenuPosition: {},
            routes: [],
            routeName: undefined,
            referralData: null,
            requestIP: undefined, // will be sent to Omega api as data
            requestUserAgent: undefined,
            user: undefined,
            socialUser: undefined,
            isUserLoggingOut: false,
            guestToken: null,
            guestCurrency: null,
            guestCountry: null,
            userEcho: undefined,
            userBalance: null,
            userBalanceInterval: null,
            userNotifications: undefined,
            playerTransactions: undefined,
            appLocale: undefined,
            locale: undefined,
            fallbackLocales: [],
            rtl: false,
            appClass: '',
            translationMessages: null,
            layoutParts: undefined,
            pagesData: {},
            sliderSlides: {},
            gamePlatformsData: undefined,
            baseDataGamePlatforms: [],
            gamePlatformItem: {},
            newsTags: [],
            newsCategories: [],
            platformGames: {},
            gamesCategories: {
                virtual: {},
                slug: {},
            },
            categoryGames: {},
            virtualCategoryGames: {},
            userFavoriteGamesIds: [],
            winnerList: [],
            promotionsData: undefined,
            pageNews: {},
            newsPagesCount: 1,
            newsItem: {},
            sliderNews: [],
            sliderPromotionsData: undefined,
            launchedGames: [],
            helpCategories: [],
            intendedUrl: undefined,
            searchText: '',
            searchGamesData: undefined,
            signIn: {
                registrationDialog: false,
                socialRegistrationDialog: false,
                loginDialog: false,
                forgotPasswordDialog: false,
                checkConfirmSignupDialog: false,
                successConfirmSignupDialog: false,
                failedConfirmSignupDialog: false,
            },
            payment: {
                depositDialog: false,
                withdrawDialog: false,
                cancelBonusWarning: false,
            },
            sidebar: {
                main: false,
                user: false,
            },
            dialogs: {
                promotion: false,
                gameMobileDialog: false,
                searchDialog: false,
                favoriteDialog: false,
                lotteryAward: false,
                lotteryWinners: false,
                fortuneWheel: false,
                notificationsPopup: false,
                supportDialog: false,
            },
            currentRecommendedGameData: undefined,
            lotteryData: {
                current: null,
                future: [],
                past: [],
                tickets: [],
                winners: [],
            },
            fortuneWheels: [],
            isFortuneWheelCaptchaPassed: false,
            tournament: {
                // my: [],
                item: {},
                list: {},
                // ranking: [],
            },
            vipLevels: [],
        },
        actions,
        mutations,
        getters
    })
}
